export default {
  userId: (state) => state.userId,
  email: (state) => state.email,
  name: (state) => state.name,
  phone: (state) => state.phone,
  memberType: (state) => state.memberType,
  logged: (state) => state.logged,
};
